type Props = {
  lightBackground: boolean
}

export const SocialLinks = (props: Props) => {
  return (
      <div className={'SocialLinks'}>

        <SocialLink url={'https://www.instagram.com/on.kensu'}
                    altText={'Kensu on Instagram'}
                    image={props.lightBackground ?
                        require('../images/icons/ig_light.png') :
                        require('../images/icons/ig_dark.png')}
        />

        <SocialLink url={'https://www.youtube.com/channel/UCUaAA4l2YKVLU2C0svBPCzw'}
                    altText={'Kensu on YouTube'}
                    image={props.lightBackground ?
                        require('../images/icons/yt_light.png') :
                        require('../images/icons/yt_dark.png')}
        />

        <SocialLink url={'https://x.com/on_kensu'}
                    altText={'Kenko on X'}
                    image={props.lightBackground ?
                        require('../images/icons/twitter_light.png') :
                        require('../images/icons/twitter_dark.png')}
        />

        <SocialLink url={'https://www.tiktok.com/@onkensu'}
                    altText={'Kensu on TikTok'}
                    image={props.lightBackground ?
                        require('../images/icons/tt_light.png') :
                        require('../images/icons/tt_dark.png')}
        />
      </div>
  );
};

type SocialLinkProps = {
  url: string,
  altText: string,
  image: string,
}

const SocialLink = (props: SocialLinkProps) => {
  return <a href={props.url} target={'_blank'}>
    <img alt={props.altText}
         className={'SocialLink'}
         src={props.image}/>
  </a>
}